import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'

// v-md-editor
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn';
import katex from 'katex' // https://katex.org/docs
import renderMathInElement from 'katex/contrib/auto-render/auto-render.js'
import 'katex/dist/katex.min.css';

import 'view-ui-plus/dist/styles/viewuiplus.css'
import ViewUIPlus from 'view-ui-plus'

VueMarkdownEditor.use(vuepressTheme);
VueMarkdownEditor.use(createKatexPlugin());

import * as ElementPlusIconsVue from '@element-plus/icons-vue'


axios.defaults.baseURL = 'https://shuatiwang.com.cn'
const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(store).use(router)
    .use(ViewUIPlus)
    .use(VueAxios, axios)
    .use(ElementPlus, { locale: zhCn })
    .use(VueMarkdownEditor)
    // .use(MdEditorV3.MdEditor)
    .use(katex)
    .mount('#app')
